import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData = {
    UserPoolId: "us-east-1_ljMlxqfZj",
    ClientId: "39a7k7u6ql6l0ibtej0p5ie8ba"
}

const userPool = new CognitoUserPool(poolData);

export default userPool;